// v2.19.22f-1 — Header auth button : login si anonyme, avatar sinon.
// v2.19.29b — Mobile fix : clic avatar = navigation directe vers /mon-compte
// (le dropdown s'ouvrait derrière le drawer et restait inaccessible).
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import AuthModal from "@/components/AuthModal";

function _initials(user) {
  if (!user) return "👤";
  const name = (user.display_name || "").trim();
  if (name) {
    const parts = name.split(/\s+/).slice(0, 2);
    const ini = parts.map((p) => p[0]?.toUpperCase() || "").join("");
    return ini || "👤";
  }
  return "👤";
}

export default function HeaderAuthControl() {
  const { user, isAuthenticated } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);

  if (!isAuthenticated) {
    return (
      <>
        <button
          type="button"
          className="civ-auth-header-btn"
          onClick={() => setAuthOpen(true)}
          data-testid="header-auth-button"
          aria-label="Se connecter ou s'inscrire"
        >
          <span>👤</span> Connexion
        </button>
        <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      </>
    );
  }

  return (
    <div className="civ-auth-header-wrap">
      <button
        type="button"
        className="civ-auth-avatar"
        onClick={() => { window.location.href = "/mon-compte"; }}
        title={user?.display_name || user?.phone || "Mon compte"}
        data-testid="header-auth-avatar"
        aria-label="Ouvrir Mon compte"
      >
        {_initials(user)}
      </button>
    </div>
  );
}
